__turbopack_context__.v({
  "pulse": "FloatingWindow-module__VOH28q__pulse",
  "resizeHandle": "FloatingWindow-module__VOH28q__resizeHandle",
  "resizeHandleCorner": "FloatingWindow-module__VOH28q__resizeHandleCorner",
  "resizeHandleLeft": "FloatingWindow-module__VOH28q__resizeHandleLeft" + " " + "FloatingWindow-module__VOH28q__resizeHandle",
  "resizeHandleTop": "FloatingWindow-module__VOH28q__resizeHandleTop" + " " + "FloatingWindow-module__VOH28q__resizeHandle",
  "resizeIcon": "FloatingWindow-module__VOH28q__resizeIcon",
  "statusDot": "FloatingWindow-module__VOH28q__statusDot",
  "windowButton": "FloatingWindow-module__VOH28q__windowButton",
  "windowButtonClose": "FloatingWindow-module__VOH28q__windowButtonClose",
});
